import { apiClient } from 'modules/app/configs/axios';

import { User } from '../interfaces';

const endpoint = '/admin/users';

export const getAllUsers = async (): Promise<User[]> => {
  try {
    const response = await apiClient.get(`${endpoint}`);
    return response.data;
  } catch (error: any) {
    throw error.data;
  }
};

export const verifyUserEmail = async (userId: number): Promise<void> => {
  try {
    const response = await apiClient.post(`${endpoint}/${userId}/verify-email`);
    return response.data;
  } catch (error: any) {
    throw error.data;
  }
};

export const resendVerificationEmail = async (userId: number): Promise<void> => {
  try {
    const response = await apiClient.post(`${endpoint}/${userId}/resend-verification`);
    return response.data;
  } catch (error: any) {
    throw error.data;
  }
};
